function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDataEmpty(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 335.91 217.64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M155.11,3h73.35l64.6,70.85-46.82,55L122.88,134.7s-43.35-25.42-47.52-27.93-32.5-32.92-32.5-32.92L107.46,3h73.35",
    style: {
      fill: "#fff",
      stroke: "#ccc",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 6
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 167.96,
    cy: 187.42,
    rx: 167.96,
    ry: 30.22,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.21,73.85s1.25,33.34-22.09,33.34H130.79c-23.33,0-22.08-33.34-22.08-33.34H42.86V178s2.91,17.51,27.92,17.51H265.13c25,0,27.93-17.51,27.93-17.51V73.85Z",
    style: {
      fill: "#f7f7f7",
      stroke: "#ccc",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 6
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDataEmpty);
export default __webpack_public_path__ + "static/media/data_empty.6620ac53dad1d7fe6f8cd3cdeb7fabd4.svg";
export { ForwardRef as ReactComponent };